export const MAX_COMPANION_CODE_LENGTH = 6;
